import './App.css';
import './index.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';




import React, { useState, useEffect } from 'react';
import Navbar from './components/Sidebar';
import Home from './pages/Home';
import WetterMondsee from './pages/WetterMondsee';
import WetterJochberg from './pages/WetterJochberg';
import Impressum from './pages/Impressum';
import Contact from './pages/Contact';
import Logo from '../src/assets/logo.png'

import WetterMurau from './pages/WetterMurau';
import WetterMuerzzuschlag from './pages/WetterMuerzzuschlag';
import WetterUnterpullendorf from './pages/WetterUnterpullendorf';
import WetterNeupoella from './pages/WetterNeupoella';
import WetterFuerstenfeld from './pages/WetterFuerstenfeld';
import WetterGippel from './pages/WetterGippel';
import WetterKlausenLeopoldsdorf from './pages/WetterKlausenLeopoldsdorf';
import WetterKollerhube from './pages/WetterKollerhube';
import WetterMatzen from './pages/WetterMatzen';
import WetterWienSchoenbrunn from './pages/WetterWienSchoenbrunn';

import BodenfeuchteMondsee from './pages/BodenfeuchteMondsee';
import BodenfeuchteKollerhube from './pages/BodenfeuchteKollerhube';
import BodenfeuchteGippel from './pages/BodenfeuchteGippel';
import BodenfeuchteJochberg from './pages/BodenfeuchteJochberg';
import BodenfeuchteKlausenLeopoldsdorf from './pages/BodenfeuchteKlausenLeopoldsdorf';
import BodenfeuchteMuerzzuschlag from './pages/BodenfeuchteMuerzzuschlag';
import BodenfeuchteMurau from './pages/BodenfeuchteMurau';
import BodenfeuchteUnterpullendorf from './pages/BodenfeuchteUnterpullendorf';
import BodenfeuchteMatzen from './pages/BodenfeuchteMatzen';
import BodenfeuchteWeitra from './pages/BodenfeuchteWeitra';
import BodenfeuchteFuerstenfeld from './pages/BodenfeuchteFuerstenfeld';

import BodentemperaturMondsee from './pages/BodentemperaturMondsee';
import BodentemperaturUnterpullendorf from './pages/BodentemperaturUnterpullendorf';
import BodentemperaturFuerstenfeld from './pages/BodentemperaturFuerstenfeld';
import BodentemperaturGippel from './pages/BodentemperaturGippel';
import BodentemperaturJochberg from './pages/BodentemperaturJochberg';
import BodentemperaturKlausenLeopoldsdorf from './pages/BodentemperaturKlausenLeopoldsdorf';
import BodentemperaturKollerhube from './pages/BodentemperaturKollerhube';
import BodentemperaturMatzen from './pages/BodentemperaturMatzen';
import BodentemperaturMuerzzuschlag from './pages/BodentemperaturMuerzzuschlag';
import BodentemperaturMurau from './pages/BodentemperaturMurau';
import BodentemperaturWeitra from './pages/BodentemperaturWeitra';


import BaumumfangJochberg from './pages/BaumumfangJochberg';
import BaumumfangKlausenLeopoldsdorf from './pages/BaumumfangKlausenLeopoldsdorf';
import BaumumfangMuerzzuschlag from './pages/BaumumfangMuerzzuschlag';
import BaumumfangMondsee from './pages/BaumumfangMondsee';
import BaumumfangMurau  from './pages/BaumumfangMurau';
import BaumumfangUnterpullendorf from './pages/BaumumfangUnterpullendorf';


import ScrollToTop from './ScrollToTop';



 

function App() {


  const [showLogo, setShowLogo] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      if (currentScrollY < windowHeight * 0.1) {
        setShowLogo(true); // Im oberen 10% Bereich → Logo sichtbar
      } else {
        if (currentScrollY > lastScrollY) {
          setShowLogo(false); // Nach unten scrollen → verstecken
        } else {
          setShowLogo(true); // Nach oben scrollen → anzeigen
        }
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    
    <Router>
      <div className="app-layout">
        <Navbar />
        <main className="main-content">
        {/*<img
            src={Logo}
            alt="Logo"
            className={`logo ${showLogo ? 'visible' : 'hidden'}`}
            width="120"
          />*/}
          <ScrollToTop />
          <Routes>
            <Route path="/" exact element={<Home />} />

            <Route path="/wetter/mondsee" element={<WetterMondsee />} />
            <Route path="/wetter/jochberg" element={<WetterJochberg />} />
            <Route path="/wetter/murau" element={<WetterMurau />} />
            <Route path="/wetter/muerzzuschlag" element={<WetterMuerzzuschlag />} />
            <Route path="/wetter/unterpullendorf" element={<WetterUnterpullendorf />} />
            <Route path="/wetter/neupoella" element={<WetterNeupoella />} />
            <Route path="/wetter/fuerstenfeld" element={<WetterFuerstenfeld />} />
            <Route path="/wetter/gippel" element={<WetterGippel />} />
            <Route path="/wetter/klausen-leopoldsdorf" element={<WetterKlausenLeopoldsdorf />} />
            <Route path="/wetter/kollerhube" element={<WetterKollerhube/>} />
            <Route path="/wetter/matzen" element={<WetterMatzen />} />
            <Route path="/wetter/wien-schoenbrunn" element={<WetterWienSchoenbrunn />} />


            <Route path="/bodenfeuchte/mondsee" element={<BodenfeuchteMondsee />} />
            <Route path="/bodenfeuchte/jochberg" element={<BodenfeuchteJochberg />} />
            <Route path="/bodenfeuchte/kollerhube" element={<BodenfeuchteKollerhube />} />
            <Route path="/bodenfeuchte/gippel" element={<BodenfeuchteGippel />} />
            <Route path="/bodenfeuchte/klausen-leopoldsdorf" element={<BodenfeuchteKlausenLeopoldsdorf />} />
            <Route path="/bodenfeuchte/muerzzuschlag" element={<BodenfeuchteMuerzzuschlag/>} />
            <Route path="/bodenfeuchte/murau" element={<BodenfeuchteMurau/>} />
            <Route path="/bodenfeuchte/unterpullendorf" element={<BodenfeuchteUnterpullendorf/>} />
            <Route path="/bodenfeuchte/matzen" element={<BodenfeuchteMatzen/>} />
            <Route path="/bodenfeuchte/weitra" element={<BodenfeuchteWeitra/>} />
            <Route path="/bodenfeuchte/fuerstenfeld" element={<BodenfeuchteFuerstenfeld/>} />


            <Route path="/bodentemperatur/mondsee" element={<BodentemperaturMondsee />} />
            <Route path="/bodentemperatur/unterpullendorf" element={<BodentemperaturUnterpullendorf />} />
            <Route path="/bodentemperatur/fuerstenfeld" element={<BodentemperaturFuerstenfeld />} />
            <Route path="/bodentemperatur/gippel" element={<BodentemperaturGippel />} />
            <Route path="/bodentemperatur/jochberg" element={<BodentemperaturJochberg />} />
            <Route path="/bodentemperatur/klausen-leopoldsdorf" element={<BodentemperaturKlausenLeopoldsdorf />} />
            <Route path="/bodentemperatur/kollerhube" element={<BodentemperaturKollerhube />} />
            <Route path="/bodentemperatur/matzen" element={<BodentemperaturMatzen />} />
            <Route path="/bodentemperatur/muerzzuschlag" element={<BodentemperaturMuerzzuschlag />} />
            <Route path="/bodentemperatur/murau" element={<BodentemperaturMurau />} />
            <Route path="/bodentemperatur/weitra" element={<BodentemperaturWeitra />} />

            <Route path="/baumumfang/mondsee" element={<BaumumfangMondsee />} />
            <Route path="/baumumfang/jochberg" element={<BaumumfangJochberg />} />
            <Route path="/baumumfang/klausen-leopoldsdorf" element={<BaumumfangKlausenLeopoldsdorf  />} />
            <Route path="/baumumfang/muerzzuschlag" element={<BaumumfangMuerzzuschlag />} />
            <Route path="/baumumfang/murau" element={<BaumumfangMurau />} />
            <Route path="/baumumfang/unterpullendorf" element={<BaumumfangUnterpullendorf />} />

            <Route path="/contact" element={<Contact />} />
            <Route path="/impressum" element={<Impressum />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
